export default {"src":"/_next/static/media/shipping3.e2838a58.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};